import { SITE_URL } from '@/constant/routes';

export function BreadcrumbLdJson({ breadcrumbs }) {
  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbs.map((breadcrumb, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: breadcrumb.label,
            item: breadcrumb.url ? SITE_URL + breadcrumb.url : undefined,
          })),
        }),
      }}
    />
  );
}
